export default __webpack_public_path__ + "static/media/icon-locked.49a269d4.svg";